export default __webpack_public_path__ + "1bacdd70b434230ffe3743cf1450abfb.png";